module.exports = __webpack_public_path__ + "img/straalstudio_logo.7658d270.svg";